/**
 * Module: ui
 * General ui behaviors
 *
 * @package mindgrub-starter-theme
 */

/**
 * Initialize ui behaviors.
 */
function init() {
	// Toggle active state.
	$( '[data-toggle-active]' ).on(
		'click',
		function(e) {
			e.preventDefault();
			var target = $( this ).data( 'toggle-active' );
			$( this ).toggleClass( 'active' );
			$( target ).toggleClass( 'active' );
		}
	);

	// Smooth scroll.
	$( '.js-scroll[href*="#"]:not([href="#"])' ).click(
		function() {
			if (location.pathname.replace( /^\//,'' ) == this.pathname.replace( /^\//,'' ) && location.hostname == this.hostname) {
				var target = $( this.hash );
				target     = target.length ? target : $( '[name=' + this.hash.slice( 1 ) + ']' );
				if (target.length) {
					$( 'html, body' ).animate(
						{
							scrollTop: target.offset().top
						},
						1000
					);
					return false;
				}
			}
		}
	);

	// Video modal functions
	$( "#modal-open" ).click(function() {
		$("#video-modal").fadeToggle();
		$('#html-video').trigger('play');
	});
	$( "#modal-close" ).click(function() {
		$("#video-modal").fadeToggle();
		$('#html-video').trigger('pause');
	});

	// Navigation toggle
	$( ".header__menu li" ).click(function() {
		$("button.header__toggle").toggleClass( "active" );
		$("#header-nav").toggleClass( "active" );
	});

	// IE 11 adjustments
	$( document ).ready(function() {
		var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

		if (isIE11) {
			// Switch various circular images with background images
			$("#modal-open img").hide();
			$("#modal-open .ie11-img").show();
			$(".side-content .image-wrap img").hide();
			$(".side-content .image-wrap .ie11-img").show();
			$("#footer-circle-img img").hide();
			$("#footer-circle-img .ie11-img").show();

			// Force percentage graph to 80% values and hide slider and slider label
			$(".slider-label").remove();
			$(".range-slider-super-container").remove();
			$("#output").addClass("rangeslider--is-80-value");
			$("#output").html($("#percentage-80").html());
			$("#percentage-graph").addClass("rangeslider--is-80-value");
			$("#percentage-value").addClass("rangeslider--is-80-value");
			$("#percentage-value").html("90%");

			// Use background image instead of svg border for CTA
			$(".cta__message").addClass("ie11");
			$(".cta-svg").remove();
		}
	});




}

/**
 * Public API
 *
 * @type {Object}
 */
module.exports = {
	init: init
};



// WEBPACK FOOTER //
// ./scripts/components/ui.js